import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL}/api`,
});

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: [
    "Offer",
    "Cart",
    "FeaturedProducts",
    "Products",
    "Checkout",
    "Wishlist",
    "FAQs",
    "FeaturedFAQs",
  ],
  endpoints: () => ({}),
  refetchOnReconnect: true,
});
